import { render, staticRenderFns } from "./BookingFormSubmission.vue?vue&type=template&id=05791a5a&scoped=true&"
import script from "./BookingFormSubmission.vue?vue&type=script&lang=js&"
export * from "./BookingFormSubmission.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=05791a5a&prod&scoped=true&lang=css&"
import style1 from "./BookingFormSubmission.vue?vue&type=style&index=1&id=05791a5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05791a5a",
  null
  
)

export default component.exports